import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const EmployeeMultiSelect = ({ employees, selectedIds, onChange, disabled }) => {
  const { t } = useTranslation();
  const toggleEmployee = (employeeId, isChecked) => {
    if (isChecked) {
      onChange([...new Set([...selectedIds, employeeId])]);
    } else {
      onChange(selectedIds.filter((id) => id !== employeeId));
    }
  };

  const hasSelection = selectedIds.length > 0;
  const triggerLabel = hasSelection ? t('pointages.multiSelect.count', { count: selectedIds.length }) : t('pointages.multiSelect.all');

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-between"
          disabled={disabled || !employees.length}
        >
          <span>{triggerLabel}</span>
          <span className="text-xs text-muted-foreground">{t('common.filter')}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-medium">{t('pointages.multiSelect.select')}</p>
          {hasSelection && (
            <Button size="sm" variant="ghost" onClick={() => onChange([])}>{t('pointages.multiSelect.clear')}</Button>
          )}
        </div>
        <div className="max-h-64 overflow-y-auto space-y-2">
          {employees.map((employee) => (
            <label key={employee.id} className="flex items-center space-x-2 text-sm">
              <Checkbox
                checked={selectedIds.includes(employee.id)}
                onCheckedChange={(checked) => toggleEmployee(employee.id, Boolean(checked))}
              />
              <span>
                {employee.registration_number || `ID ${employee.id}`} – {employee.full_name || `${employee.first_name} ${employee.last_name}`}
              </span>
            </label>
          ))}
          {!employees.length && (
            <p className="text-sm text-muted-foreground">{t('pointages.multiSelect.emptyDept')}</p>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default EmployeeMultiSelect;
